export default class Orders{
  constructor(){
    
  }
}